import {Component, Inject} from '@angular/core';
import {ProcessorAPI, FourDService, Project} from '4d-mapper';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar} from '@angular/material';
import {AccessGroup} from 'vasat';
import {AppService} from '../../commons/app.service';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
import { AclService } from '../../commons/acl/acl.service';

@Component({
  selector: 'user-dialog',
  templateUrl: './user-add.dialog.html',
})

export class AddUserDialog extends AppBaseComponent {

  curApi: ProcessorAPI
  group: AccessGroup
  mod: any = {}
  showProjects:boolean
  projects:Project[] = []

  projectsHash = {}

  role:any
  constructor(public dialogRef: MatDialogRef<AddUserDialog>, 
      @Inject(MAT_DIALOG_DATA) public data: any,
      public fourD: FourDService, 
      public service: AppService, 
      public router: Router, 
      acl:AclService,
              public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);
    this.projects = fourD.projects

  }

  ok() {
    if (!/\S+@\S+\.\S+/.test(this.mod.email)) {
      this.openSnackBarError('SIGNIN.EMAIL_INVALID')
      return;
    }
    
    this.mod.projects = Object.keys(this.projectsHash).filter(k => this.projectsHash[k]).map(k => parseInt(k))
    
    this.dialogRef.close({group: this.group, user: this.mod})
  }

  cancel() {
    this.dialogRef.close()
  }

  updateState(){
    this.showProjects = !this.group.uid.endsWith('_admins')
  }
}
